module.exports = __webpack_public_path__ + "static/img/guide_background_prod.7f08dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_background_prod.png
// module id = jw1r
// module chunks = 1